import { NAME as APP_NAME, AUTHORITIES as APP_AUTHORITIES } from '../constants';

export const NAME = `${APP_NAME}/SHIPMENT_ESCALATION`;

export const REDUCER_NAME = 'shipmentEscalation';
export const LISTING_ENDPOINT = `${SHIPPING_EDGE}/api/masheed/v2/escalated-shipments`;

export const AUTHORITIES = APP_AUTHORITIES;

export const ROUTES = {
  ROOT: '/shipment-escalation',
  ROOT2: '/shipment-alerts',
};
